// encode object -> Base64(JSON)
export const encodeBase64 = (input: unknown): string | null => {
  try {
    const json = JSON.stringify(input);
    const bytes = new TextEncoder().encode(json); // UTF-8
    let bin = '';
    let i: number;
    for (i = 0; i < bytes.length; i++) {
      bin += String.fromCharCode(bytes[i]);
    }
    return btoa(bin); // standard Base64
  } catch {
    return null;
  }
};

// decode Base64(JSON) -> object
export const decodeBase64 = <T = unknown>(b64: string): T => {
  // Replace URL-safe characters and remove any whitespace
  const normalized = b64
    .replace(/-/g, '+')
    .replace(/ /g, '+')
    .replace(/_/g, '/')
    .replace(/\s/g, '');

  const bin = atob(normalized);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    bytes[i] = bin.charCodeAt(i);
  }
  const json = new TextDecoder().decode(bytes);
  return JSON.parse(json) as T;
};
